import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const AboutUs = () => {
     useEffect(() => {
        document.title = 'About Us -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li>About Us </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>About Us  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p>St. Peter's Convent School, Sector 88, Greater Faridabad is a recognized unaided Christian minority institution, established in <b>2013</b>. Affiliated to the Central Board of Secondary Education (CBSE), New Delhi <b>(Affiliation No. 531674, School Code 41651),</b> the school provides a nurturing environment focused on academic excellence, character formation, and the holistic growth of every student. </p>

       <p>The school is administered by the Sisters of the Congregation of the Mother of Carmel (CMC)—a pioneering religious and charitable institution with over <b>150 </b> years of distinguished service in education. Since its founding in <b>1866</b>, the CMC has established and manages hundreds of educational institutions across India and abroad, including schools, colleges, and vocational training centers. </p>
       
       <p>Rooted in this rich legacy, St. Peter’s Convent School is committed to equipping children with the knowledge, values, and skills needed for success in the 21st century. The school fosters intellectual curiosity, critical thinking, creativity, and moral responsibility, empowering students to become capable, compassionate, and future-ready global citizens. </p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default AboutUs
